import { InternalRefetchQueriesInclude } from '@apollo/client'
import { ActionIcon, Tooltip } from '@mantine/core'

import { useMutation } from '@redwoodjs/web'

import { toast } from 'src/components/Overlays/Toast/Toast'
import { GENERATE_VOE_AUDIT_TRAIL_PDF } from 'src/graphql/voe.graphql'
import IconChecklist from 'src/icons/IconChecklist'

export const GENERATE_AUDIT_TRAIL_PDF_LABEL = 'Generate audit trail PDF'

/**
 * Files a printable record of the VoE's contact attempts under its Documents
 */
const GenerateAuditTrailPdfButton = ({
  voeId,
  refetchQueries,
}: {
  voeId: string
  refetchQueries?: InternalRefetchQueriesInclude
}) => {
  const [generate, { loading }] = useMutation(GENERATE_VOE_AUDIT_TRAIL_PDF, {
    variables: { voeId },
    refetchQueries,
    awaitRefetchQueries: true,
    onCompleted: () => {
      toast('Audit trail PDF added to Documents', 'success')
    },
    onError: (error) => {
      toast(
        error.message ||
          'Unable to generate the audit trail PDF, please try again.',
        'error'
      )
    },
  })

  return (
    <Tooltip label={GENERATE_AUDIT_TRAIL_PDF_LABEL} position="bottom-end">
      <ActionIcon
        aria-label={GENERATE_AUDIT_TRAIL_PDF_LABEL}
        aria-busy={loading}
        variant="subtle"
        color="gray"
        size="sm"
        loading={loading}
        onClick={() => {
          if (!loading) generate()
        }}
        className="h-6 w-6 hover:bg-doubleNickel-gray-100"
      >
        <IconChecklist className="h-3.5 w-3.5 fill-none stroke-doubleNickel-gray-600" />
      </ActionIcon>
    </Tooltip>
  )
}

export default GenerateAuditTrailPdfButton
